export function completeSellerTourBeforeOAuth(
  completeActivation: (() => void) | undefined,
  authorizeUrl: string,
  assign: (url: string) => void = (url) => window.location.assign(url),
): void {
  completeActivation?.()
  assign(authorizeUrl)
}
